import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a45abb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.button === 'Add Artist')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitShowPopup && _ctx.emitShowPopup(...args)))
        }, _toDisplayString(_ctx.button), 1))
      : (_ctx.button === 'Add Artwork')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "artworks/new",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.button), 1)
            ]),
            _: 1
          }))
        : (_ctx.button === 'Add Show')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: "/shows/add",
              type: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.button), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "Search...",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitSearch && _ctx.emitSearch(...args)))
    }, null, 544), [
      [_vModelText, _ctx.search]
    ])
  ]))
}